import { adminApi, publicApi } from './http';

const SKILL_UPLOAD_TIMEOUT = 10 * 60 * 1000;

export const fetchPublicSkills = (params = {}) => publicApi.get('/skills', { params });

export const fetchPublicSkillDetail = (id) => publicApi.get(`/skills/${id}`);

export const fetchAdminSkills = (params = {}) => adminApi.get('/skills', { params });

export const fetchAdminSkillDetail = (id) => adminApi.get(`/skills/${id}`);

export const createAdminSkill = (payload) => adminApi.post('/skills', payload);

export const updateAdminSkill = (id, payload) => adminApi.put(`/skills/${id}`, payload);

export const deleteAdminSkill = (id) => adminApi.delete(`/skills/${id}`);

export const uploadAdminSkillFile = (file) => {
  const formData = new FormData();

  formData.append('file', file);

  return adminApi.post('/skills/files', formData, {
    timeout: SKILL_UPLOAD_TIMEOUT,
  });
};
